jQuery(window).on("load", function () {
  $(".twentytwenty-container").twentytwenty();
});
jQuery(document).ready(function($){
    // Video play
    let videoContainer = $('.product--video__wrapper');
    videoContainer.on('click', function () {
      let getIDVideo = $(this).attr('data-video');
      let video = $('#productVideo[data-video=' +  getIDVideo + ']')[0];
        if (video.paused) {
          video.play();
          videoContainer.addClass('playing')
        } else {
          video.pause();
          videoContainer.removeClass('playing')
        }
    });

    const youtubePlayers = {};
    const YT_API_URL = 'https://www.youtube.com/iframe_api';

    function loadYouTubeIframeAPI() {
      if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
      if (window._youtubeIframeApiPromise) return window._youtubeIframeApiPromise;

      window._youtubeIframeApiPromise = new Promise(function(resolve) {
        const scriptTag = document.querySelector('script[src="' + YT_API_URL + '"]');
        if (!scriptTag) {
          const tag = document.createElement('script');
          tag.src = YT_API_URL;
          document.head.appendChild(tag);
        }

        const previousReady = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function() {
          if (typeof previousReady === 'function') previousReady();
          resolve(window.YT);
        };
      });

      return window._youtubeIframeApiPromise;
    }

    function toggleYoutubeOverlay(iframeEl, isVisible) {
      const wrapper = iframeEl.closest('.product-main-gallery__deferred-media');
      if (!wrapper) return;
      const overlay = wrapper.querySelector('.product-youtube-overlay');
      if (!overlay) return;
      overlay.classList.toggle('is-visible', isVisible);
    }

    function initYoutubePlayer(iframeEl) {
      if (!iframeEl) return;
      if (iframeEl.dataset.ytPlayerBound === 'true') return;
      iframeEl.dataset.ytPlayerBound = 'true';

      if (!iframeEl.id) {
        iframeEl.id = 'yt-player-' + Math.random().toString(36).slice(2, 10);
      }

      loadYouTubeIframeAPI().then(function() {
        if (youtubePlayers[iframeEl.id]) return;
        youtubePlayers[iframeEl.id] = new window.YT.Player(iframeEl.id, {
          events: {
            onStateChange: function(event) {
              const playerIframe = event.target && event.target.getIframe ? event.target.getIframe() : iframeEl;
              if (!playerIframe || !window.YT || !window.YT.PlayerState) return;

              if (event.data === window.YT.PlayerState.PLAYING) {
                toggleYoutubeOverlay(playerIframe, false);
              } else if (
                event.data === window.YT.PlayerState.PAUSED ||
                event.data === window.YT.PlayerState.ENDED
              ) {
                toggleYoutubeOverlay(playerIframe, true);
              }
            }
          }
        });
      });
    }

    function initYoutubePlayersIn(context) {
      $(context).find('iframe.js-youtube').each(function() {
        initYoutubePlayer(this);
      });
    }

    $(document).on('click', '.product-youtube-overlay', function(e) {
      e.preventDefault();
      const wrapper = this.closest('.product-main-gallery__deferred-media');
      if (!wrapper) return;
      const iframeEl = wrapper.querySelector('iframe.js-youtube');
      if (!iframeEl) return;

      const player = youtubePlayers[iframeEl.id];
      if (player && typeof player.playVideo === 'function') {
        player.playVideo();
      } else if (iframeEl.contentWindow) {
        iframeEl.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }

      this.classList.remove('is-visible');
    });

    $(document).on('click', '#js-main-product-gallery [id^="Deferred-Poster-"]', function() {
      const deferredMedia = $(this).closest('.product-main-gallery__deferred-media')[0];
      if (!deferredMedia) return;
      setTimeout(function() {
        initYoutubePlayersIn(deferredMedia);
      }, 250);
    });


    $("#js-main-product-gallery").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '#js-product-gallery',
      arrows: true,
      adaptiveHeight: true,
      nextArrow: '<button class="slick-next slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
      prevArrow: '<button class="slick-prev slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
      responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          nextArrow: '<button class="slick-next slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
          prevArrow: '<button class="slick-prev slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
          
        }
      }
      ]
    });
    // $(".js-product-gallery").on("init", function(event, slick){
    //   const maxPages = Math.ceil(slick.slideCount);	  
    //   if(maxPages < 5){
    //     $('.slick-thumb-img').addClass('no-run-slick')
    //   }
    // });
    $("#js-product-gallery").slick({
      vertical: true,
      verticalSwiping: true,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      focusOnSelect: true,
      asNavFor: '#js-main-product-gallery',
      focusOnSelect: true,
      nextArrow: '<button class="slick-next slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
      prevArrow: '<button class="slick-prev slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            vertical: false,
            verticalSwiping: false,
            nextArrow: '<button class="slick-next slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
            prevArrow: '<button class="slick-prev slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          nextArrow: '<button class="slick-next slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
          prevArrow: '<button class="slick-prev slider-button slick-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
        }
      }
      ] 
    });

    // Auto play video when slide changes (click thumbnail or arrow)
    $("#js-main-product-gallery").on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      // Pause all videos/iframes in current slide before changing
      var $currentSlideEl = $(slick.$slides[currentSlide]);
      $currentSlideEl.find('video').each(function() {
        this.pause();
      });
      $currentSlideEl.find('.js-youtube').each(function() {
        if (this.contentWindow) {
          this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
      });
      $currentSlideEl.find('.js-vimeo').each(function() {
        if (this.contentWindow) {
          this.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
    });

    $("#js-main-product-gallery").on('afterChange', function(event, slick, currentSlide) {
      var $currentSlideEl = $(slick.$slides[currentSlide]);
      var $deferred = $currentSlideEl.find('deferred-media');

      if ($deferred.length > 0) {
        var deferredEl = $deferred[0];
        // Check if it's a video slide and auto-load it
        if (typeof deferredEl.loadContent === 'function' && !deferredEl.hasAttribute('loaded')) {
          deferredEl.loadContent(false);
        } else {
          // Already loaded, just play
          var video = $deferred.find('video')[0];
          var youtubeIframe = $deferred.find('.js-youtube')[0];
          var vimeoIframe = $deferred.find('.js-vimeo')[0];

          if (video && video.paused) {
            video.play().catch(function() {});
          }
          if (youtubeIframe && youtubeIframe.contentWindow) {
            youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
          if (vimeoIframe && vimeoIframe.contentWindow) {
            vimeoIframe.contentWindow.postMessage('{"method":"play"}', '*');
          }
        }
      }

      initYoutubePlayersIn($currentSlideEl);
    });

    initYoutubePlayersIn(document);

    $(".icon-loading").addClass('hidden');
    $(".wrap-slider-slick").removeClass('hidden');

    
  $.fancybox.defaults.loop = true;
	$('[data-fancybox="gallery"]').fancybox({
		loop: true
	});
  
})

$(document).ready(function() {

  $(".product--faq__title").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".product--faq__detail")
        .slideUp(200);
      $(".product--faq__title i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".product--faq__title i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".product--faq__title").removeClass("active");
      $(this).addClass("active");
      $(".product--faq__detail").slideUp(200);
      $(this)
        .siblings(".product--faq__detail")
        .slideDown(200);
    }
  });

  $(".js-choose-faq li").on("click", function() {
    $(".product--faq__title").removeClass('active');
    $(".product--faq__detail").hide();
    $(".js-choose-faq li").removeClass('active');
    $(this).addClass('active');
    const get_pos_title = $(this).attr('data-title');
    $(".product--faq__blocks").hide();
    $(".product--faq__blocks[data-section=faq_"+ get_pos_title + "]").show();
  })

  function initStickyAddToCartScroll() {
    var sticky = document.querySelector('.sticky-addtocart[data-section-id]');
    var buyRow = document.querySelector('.product-qty-buy-row');
    if (!sticky || !buyRow) return;

    function setStickyVisible(scrolledPast) {
      sticky.classList.toggle('is-visible', scrolledPast);
      sticky.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        setStickyVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: [0, 1] });
      observer.observe(buyRow);
    } else {
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          setStickyVisible(buyRow.getBoundingClientRect().bottom < 0);
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function initStickyProductQuantitySync() {
    var root = document.querySelector('.sticky-addtocart[data-section-id]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;
    var main = document.getElementById('Quantity-' + sectionId);
    var sticky = document.getElementById('Quantity-Sticky-' + sectionId);
    if (!main || !sticky) return;

    var syncing = false;

    function copyAttrsMainToSticky() {
      sticky.value = main.value;
      ['min', 'max', 'step'].forEach(function (attr) {
        if (main.hasAttribute(attr)) sticky.setAttribute(attr, main.getAttribute(attr));
        else sticky.removeAttribute(attr);
      });
      ['data-cart-quantity', 'data-min', 'data-max'].forEach(function (attr) {
        if (main.hasAttribute(attr)) sticky.setAttribute(attr, main.getAttribute(attr));
        else sticky.removeAttribute(attr);
      });
    }

    function onMainInputOrChange() {
      if (syncing) return;
      syncing = true;
      copyAttrsMainToSticky();
      syncing = false;
    }

    function onStickyInputOrChange() {
      if (syncing) return;
      syncing = true;
      var v = parseInt(sticky.value, 10);
      if (Number.isNaN(v)) {
        v = parseInt(main.getAttribute('data-min'), 10) || 1;
      }
      var mn = main.hasAttribute('min') ? parseInt(main.min, 10) : null;
      var mx = main.hasAttribute('max') ? parseInt(main.max, 10) : null;
      if (mn !== null && v < mn) v = mn;
      if (mx !== null && !Number.isNaN(mx) && v > mx) v = mx;
      main.value = String(v);
      sticky.value = String(v);
      main.dispatchEvent(new Event('input', { bubbles: true }));
      main.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }

    main.addEventListener('input', onMainInputOrChange);
    main.addEventListener('change', onMainInputOrChange);
    sticky.addEventListener('input', onStickyInputOrChange);
    sticky.addEventListener('change', onStickyInputOrChange);

    copyAttrsMainToSticky();
  }

  $(".js-sticky-addtocart").on("click", function () {
    $('.product-form .product-form__submit').first().trigger('click');
  });

  $(".js-sticky-plus").on("click", function () {
    $('.product__info-container .quantity__button[name="plus"]').first().trigger('click');
  });

  $(".js-sticky-minus").on("click", function () {
    $('.product__info-container .quantity__button[name="minus"]').first().trigger('click');
  });

  initStickyAddToCartScroll();
  initStickyProductQuantitySync();

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      var root = document.querySelector('.sticky-addtocart[data-section-id]');
      if (!root) return;
      var sectionId = root.getAttribute('data-section-id');
      var main = document.getElementById('Quantity-' + sectionId);
      var sticky = document.getElementById('Quantity-Sticky-' + sectionId);
      if (!main || !sticky) return;
      sticky.value = main.value;
      ['min', 'max', 'step', 'data-cart-quantity', 'data-min', 'data-max'].forEach(function (attr) {
        if (main.hasAttribute(attr)) sticky.setAttribute(attr, main.getAttribute(attr));
        else sticky.removeAttribute(attr);
      });
    });
  }

});

(function initScrollToTop() {
  var btn = document.querySelector('[data-scroll-to-top]');
  if (!btn) return;

  var threshold = 400;

  function setVisible(visible) {
    btn.classList.toggle('is-visible', visible);
    btn.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function onScroll() {
    setVisible(window.scrollY > threshold);
  }

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
